// Menu entries for site-nav (the top bar and the phone drawer).
// `icon` is a Font Awesome v5 name, used with the `fa` prefix like the rest of
// the site (the FA kit doesn't understand v6-only classes such as `fa-solid`).
// `brand: true` marks a brand icon (uses the `fab` prefix instead of `fa`).
// An entry with `children` is a submenu ("More").
export const navItems = [
	{ label: "Home", route: "/", icon: "home" },
	{ label: "Posts", route: "/posts", icon: "newspaper" },
	{ label: "Staff", route: "/staff", icon: "users" },
	{ label: "Giving", url: "https://www.elexiogiving.com/app/giving/gracesa", icon: "hand-holding-heart" },
	{ label: "Calendar", route: "/calendar", icon: "calendar-alt" },
	{ label: "About", route: "/who-we-are", icon: "church" },
	{
		label: "More",
		icon: "ellipsis-h",
		children: [
			{ label: "History", route: "/history", icon: "history" },
			{ label: "Documents", url: "https://drive.google.com/drive/folders/10b8FUw8RVhuEHe3aDG_Rutvv73Wx6YWF?usp=sharing", icon: "folder-open" },
			{ label: "Forms", route: "/forms", icon: "file-alt" },
			{ label: "Ministry Partners", route: "/partners", icon: "handshake" },
			{ label: "Facebook", url: "https://www.facebook.com/GraceSanAntonio", icon: "facebook", brand: true },
			{ label: "YouTube", url: "https://m.youtube.com/channel/UCY3TbSbq6QGcpzhcZm45wsA?fs=e&s=cl", icon: "youtube", brand: true },
		],
	},
];
